export enum FeaturePosition {
  statisticCard = 'feature_statisticCard',
  pie = 'feature_pie',
  line = 'feature_line',
  column = 'feature_column',
  dynamic = 'feature_dynamic',
}
